export default __webpack_public_path__ + "static/media/carcar.2f6b3137.jpg";